import { useEffect, useState } from "react";

export function useTheme() {
  const [theme, setTheme] = useState<"auto" | "dark" | "light">("auto");
  const [isDark, setIsDark] = useState<boolean>(false);

  useEffect(() => {
    const stored = localStorage.getItem("theme") as
      | "auto"
      | "dark"
      | "light"
      | null;
    if (stored) setTheme(stored);
  }, []);

  useEffect(() => {
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;

    if (theme === "auto") {
      setIsDark(prefersDark);
    } else {
      setIsDark(theme === "dark");
    }
  }, [theme]);

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDark]);

  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  return { theme, setTheme, isDark };
}
